var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-container"},[_c('div',{staticClass:"circle-outline"},[_c('div',{staticClass:"circle",style:(_vm.styleCircle)},[_c('span',{staticClass:"message",style:(_vm.styleMessage)},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }